var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.b()},_vm._l((_vm.members),function(member){return _c('li',{key:member.id,class:_vm.b('item')},[_c('c-person',{attrs:{"person":member,"image-sizes":_vm.sizes}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }